import './App.css';
import Canvas from "./components/canvas"
import Color from './components/color';

function App() {
  
  return (
    <div className="App">
      <Color/>
      <Canvas />
    </div>
  );
}

export default App;
